module.exports = __webpack_public_path__ + "static/img/image-not-found.4a2effb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-not-found.jpg
// module id = 6Lt5
// module chunks = 1